module.exports = __webpack_public_path__ + "02b538f5006d1b52554f30f00c2a2ac1.svg";